if (!customElements.get('membership-promo')) {
  customElements.define(
    'membership-promo',
    class MembershipPromo extends HTMLElement {
      connectedCallback() {
        const pricesElement = this.querySelector('[data-membership-variant-prices]');

        try {
          this.variantPrices = JSON.parse(
            pricesElement ? pricesElement.textContent : '{}'
          );
        } catch (error) {
          this.variantPrices = {};
        }

        this.memberPriceElement = this.querySelector('[data-membership-member-price]');
        this.savingsElement = this.querySelector('[data-membership-savings]');
        this.handleDocumentChange = this.handleDocumentChange.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleVariantEvent = this.handleVariantEvent.bind(this);

        document.addEventListener('change', this.handleDocumentChange);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('touchend', this.handleDocumentClick, { passive: true });
        document.addEventListener('variant:change', this.handleVariantEvent);
        document.addEventListener('product:variant-change', this.handleVariantEvent);
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.handleDocumentChange);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('touchend', this.handleDocumentClick);
        document.removeEventListener('variant:change', this.handleVariantEvent);
        document.removeEventListener('product:variant-change', this.handleVariantEvent);
      }

      handleDocumentChange(event) {
        const variantInput = event.target.closest('input[name="id"], select[name="id"]');

        if (variantInput) {
          this.updatePrices(variantInput.value);
          return;
        }

        const variantPicker = event.target.closest('variant-radios, variant-selects');
        if (!variantPicker || variantPicker.dataset.section !== this.dataset.sectionId) return;

        requestAnimationFrame(() => {
          const productForm = document.getElementById(`product-form-${this.dataset.sectionId}`);
          const productInput = productForm
            ? productForm.querySelector('[name="id"]')
            : null;
          this.updatePrices(productInput ? productInput.value : null);
        });
      }

      handleDocumentClick(event) {
        const customVariant = event.target.closest(
          '.variant__box, .variants-picker__material, .variants-picker__color'
        );

        if (!customVariant) return;

        const variantId =
          customVariant.dataset.id ||
          customVariant.dataset.variantId ||
          customVariant.getAttribute('data-variant-id');

        this.updatePrices(variantId);
      }

      handleVariantEvent(event) {
        const detail = event.detail || {};
        const variantId =
          detail.variantId ||
          (detail.variant ? detail.variant.id : null) ||
          detail.id;
        this.updatePrices(variantId);
      }

      updatePrices(variantId) {
        if (!variantId) return;

        const values = this.variantPrices[String(variantId)];
        if (!values) return;

        if (this.memberPriceElement) {
          this.memberPriceElement.textContent = values.memberPrice;
        }

        if (this.savingsElement) {
          this.savingsElement.textContent = values.savings;
        }

        this.dataset.selectedVariantId = variantId;
      }
    }
  );
}
